<template>
	<div>
		<v-navigation-drawer
			v-model="showPanel"
			ref="settingsDrawer"
			location="right"
			temporary
			:elevation="0"
			floating
			width="350"
			class="settingsDrawer"
		>
			<v-list>
				<v-list-item
					title="Settings"
				>
					<template v-slot:append>
						<v-btn
							variant="text"
							icon="mdi-close"
							@click="$emit('close')"
						></v-btn>
					</template>
				</v-list-item>
			</v-list>

			<v-divider></v-divider>

			<v-list density="compact" nav class="mt-5">
				<div class="pa-2">

						<v-list-item prepend-icon="mdi-calendar-clock" title="Set Spending Cycle" href="/#/setupspendinganalysis" />
						<v-list-item v-if="showLogout" prepend-icon="mdi-logout" title="Logout" href="MG_POP.html?view=logout" />
						<v-list-item prepend-icon="mdi-bell" title="View Notifications" href="/#/allnotifications"></v-list-item>
						<v-list-item prepend-icon="mdi-cog" title="Notification Settings" href="/#/notifications"></v-list-item>
						<v-list-item prepend-icon="mdi-chat" title="WhatsApp Settings" href="/#/enablewhatsapp"></v-list-item>
						<v-list-item prepend-icon="mdi-file-document-outline" title="Documents" href="/#/money?filter=docs"></v-list-item>
						<v-divider></v-divider>
						<v-list-item v-if="isAdminUser" prepend-icon="mdi-account" title="Admin Dashboard" href="/#/admin" />
						<v-divider></v-divider>
						<!-- <v-list-item
							title="Experimental Features"
						/> -->
						
				</div>
			</v-list>

			<template v-slot:append>
				<div class="pa-2">
					<v-list density="compact" nav>
						<v-list-item v-if="showHiddenSettings"
							prepend-icon="mdi-cached"
							title="Use Local Cache"
						>
							<template v-slot:append>
								<v-switch
									v-model="useLocalCache"
									inset
									hide-details
									:color="useLocalCache ? 'rgb(224, 197, 200)' : 'grey'"
								></v-switch>
							</template>
						</v-list-item>

						<v-list-item v-if="showHiddenSettings"
							prepend-icon="mdi-cached"
							title="Use Cached Endpoints"
						>
							<template v-slot:append>
								<v-switch
									v-model="useCachedEndpoints"
									inset
									hide-details
									:color="useCachedEndpoints ? 'rgb(224, 197, 200)' : 'grey'"
								></v-switch>
							</template>
						</v-list-item>

						<v-list-item
							prepend-icon="mdi-lightning-bolt"
							title="Hide Financial Figures"
						>
							<template v-slot:append>
								<v-switch
									v-model="randomiseFigures"
									inset
									hide-details
									:color="randomiseFigures ? 'rgb(224, 197, 200)' : 'grey'"
								></v-switch>
							</template>
						</v-list-item>
						<v-list-item
							title="Clear Cache"
							@click="this._clearHttpCache"
						/>
						<v-list-item
							title="Terms and Conditions"
							href="https://www.moneyguided.com/#/terms"
						/>
						<v-list-item
							title="Privacy Policy"
							href="https://www.moneyguided.com/#/policy"
						/>
							<v-list-item
							:title="'Money Guided 2025 - Version ' + this.appVersion + ' (' + parseInt(this.$cookies.get('st')) + ', ' + parseInt(this.$cookies.get('sb')) + ')'"
							class="small-text"
						/>
					</v-list>
				</div>
			</template>
		</v-navigation-drawer>

	</div>
</template>

<script>
import Services from '../../mixins/Services';
import { checkIsAdmin } from '../../utils/authUtils';

export default {
	name: 'AppSettingsDrawer',
	mixins: [Services],
	data() {
		return {
			showPanel: false,
			showLogout: false,
			randomiseFigures: localStorage.getItem('randomiseFigures') === 'true',
			newVoucherWallet: localStorage.getItem('newVoucherWallet') === 'true',
			showHiddenSettings: localStorage.getItem('showHiddenSettings') === 'true',
			useLocalCache: localStorage.getItem('useLocalCache') === 'true',
			useCachedEndpoints: localStorage.getItem('useCachedEndpoints') === 'true',
		}
	},
	computed: {
		isAdminUser() {
			return checkIsAdmin(this.$cookies);
		}
	},
	methods: {
		onLoad() {
			//this._getNotifications();
			// DO NOT PERFORM API CALLS HERE
			// THIS PAGE IS INCLUDED APP WIDE AND WILL BREAK UNAUATHENTICATED PAGES
		},
		show: function () {
			this.showPanel = true;
		},
		hide: function () {
			this.showPanel = false;
		},
		toggle: function () {
			this.showPanel = !this.showPanel;
		},
	},
	mounted() {
		this.onLoad();
	},
	watch: {
		randomiseFigures(val) {
			localStorage.setItem('randomiseFigures', val);
		},
		newVoucherWallet(val) {
			localStorage.setItem('newVoucherWallet', val);
		},
		useLocalCache(val) {
			localStorage.setItem('useLocalCache', val);
		},
		useCachedEndpoints(val) {
			localStorage.setItem('useCachedEndpoints', val);
		},
	}
}
</script>

<style scoped>

:deep(.settingsDrawer) {
	border: 1px solid var(--border-color);
	border-right: 0px;
	border-top-left-radius: 10px;
	border-bottom-left-radius: 10px;
  top: 60px !important;
  max-height: calc(100vh - 133px) !important;
	.v-list {
		padding-top: 0px;
		padding-bottom: 0px;
	}
}

.small-text {
  color: var(--text-color);
  opacity: 0.6;
}

</style>
